"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
exports.alphaIndexMap = exports.alphabet.reduce(function (obj, a, i) {
    var _a;
    return __assign(__assign({}, obj), (_a = {}, _a[a] = i, _a[a.toLowerCase()] = i, _a));
}, {});
